export default __webpack_public_path__ + "static/media/calls-promo.0420e941.png";